<template lang="pug">
    v-img.shrink(
        alt="Pulse Icon"
        contain
        src="https://volie-assets.s3.us-east-1.amazonaws.com/system/pulse_branding/PulsePrimaryReverseLogo_NoTag_Icon.png"
        :width="size"
    )

</template>

<!-- No tm on this asset -->

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        data() {
            return {}
        },
        computed: {},
        props: {
            size: {
                type: Number,
                default: 62,
            },
        },
    });
</script>

<style lang="scss" scoped>
</style>
